<div style="margin-bottom: 43px; font-size: 20px; font-weight: 600;">
  Add Sponsor/Owner details
  <!-- {{ role === 'distributor' ? 'Add Sponsor/Owner details' : 'Add business owner & incharge details' }} -->
</div>
<div>
  <form [formGroup]="form" (ngSubmit)="submit()">
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    <button type="submit" pButton size="large" class="btn btn-primary mt-6 cursor-pointer">Finish
      <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
    </button>
  </form>
</div>